module.exports = __webpack_public_path__ + "img/diagram-venn.5812824d.svg";